import { render } from "./ReportesIngresos.vue?vue&type=template&id=36de0e91"
import script from "./ReportesIngresos.vue?vue&type=script&lang=js"
export * from "./ReportesIngresos.vue?vue&type=script&lang=js"

import "./ReportesIngresos.vue?vue&type=style&index=0&id=36de0e91&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__